<app-page-container [props]="props"  [title]="title"
 class="ase-container" [layoutType]="LayoutType.IntegratedTab" [tabConfig]="tabConfig">
</app-page-container>